module.exports = __webpack_public_path__ + "img/bg_tiktok_ads.b2136507.png";